import api from "utils/api";
import { transformDistributionBoardV3 } from "./transformDistributionBoardV3";
import type {
  DiagramRecord,
  BoardDiagramV3,
  BoardDiagramPageV3,
} from "./types";
import type { DistributionBoardBOQQuantityEntry } from "components/SmartSurveyor/ReviewPage/DistributionBoardBOQByQuantity/types";

interface FetchSingleDiagramArgs {
  diagramRecord: DiagramRecord;
}

interface DiagramStructuredData {
  entries: DistributionBoardBOQQuantityEntry[];
  pages: BoardDiagramPageV3[];
}

// Only backend-signed CloudFront URLs are usable; unsigned keys stay unreachable.
const signedUrlOrEmpty = (url: string | undefined): string =>
  url && url.startsWith("http") ? url : "";

export const fetchSingleDiagram = async ({
  diagramRecord,
}: FetchSingleDiagramArgs): Promise<BoardDiagramV3 | null> => {
  const { entries, pages }: DiagramStructuredData =
    await api.getQuantitySurveyorDiagramStructuredData(diagramRecord.id);

  for (const entry of entries) {
    for (const diagram of entry.diagrams ?? []) {
      for (const page of diagram.pages ?? []) {
        page.imageUrl = signedUrlOrEmpty(page.imageUrl);
        page.pdfUrl = signedUrlOrEmpty(page.pdfUrl);
      }
    }
  }

  const diagram = transformDistributionBoardV3(entries)[0];
  if (diagram === undefined) return null;
  return {
    ...diagram,
    pages: pages.map((page) => ({
      ...page,
      imageUrl: signedUrlOrEmpty(page.imageUrl),
      pdfUrl: signedUrlOrEmpty(page.pdfUrl),
    })),
  };
};
